import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { AccountModule, AccountState } from './account.module';
import { AchievementsModule, AchievementsState } from './achievements.module';
import { ActivitiesModule, ActivitiesState } from './activities.module';
import { BadgesModule, BadgesState } from './badges.module';
import { FeedbackModule } from './feedback.module';
import { GCoinsModule, GCoinsState } from './gcoins.module';
import { GeekModule, GeekState } from './geek.module';
import { GuidesModule, GuidesState } from './guides.module';
import { HistoryModule, HistoryState } from './history.module';
import { ManagementModule, ManagementState } from './management.module';
import { NewsModule, NewsState } from './news.module';
import { NotificationsModule, NotificationsState } from './notifications.module';
import { OpportunitiesModule, OpportunitiesState } from './opportunities.module';
import { RulesModule, RulesState } from './rules.module';
import { ScoresModule, ScoresState } from './scores.module';
import { SeasonsModule, SeasonsState } from './seasons.module';
import { ThemeState, ThemeModule } from './themes.module';
import { UsersModule, UsersState } from './users.module';
import { KitchenTvState, KitchenTvModule } from './kitchen-tv.module';

Vue.use(Vuex);

export interface RootState {
  account: AccountState;
  achievements: AchievementsState;
  activities: ActivitiesState;
  badges: BadgesState;
  gCoins: GCoinsState;
  geek: GeekState;
  guides: GuidesState;
  history: HistoryState;
  kitchenTv: KitchenTvState;
  management: ManagementState;
  news: NewsState;
  notifications: NotificationsState;
  opportunities: OpportunitiesState;
  rules: RulesState;
  scores: ScoresState;
  seasons: SeasonsState;
  themes: ThemeState;
  users: UsersState;
}

export const RootStore = new Vuex.Store<RootState>({
  modules: {
    account: AccountModule,
    achievements: AchievementsModule,
    activities: ActivitiesModule,
    badges: BadgesModule,
    feedback: FeedbackModule,
    gCoins: GCoinsModule,
    geek: GeekModule,
    guides: GuidesModule,
    history: HistoryModule,
    kitchenTv: KitchenTvModule,
    management: ManagementModule,
    news: NewsModule,
    notifications: NotificationsModule,
    opportunities: OpportunitiesModule,
    rules: RulesModule,
    scores: ScoresModule,
    seasons: SeasonsModule,
    themes: ThemeModule,
    users: UsersModule,
  },
});

export function typedStore(component: Vue): Store<RootState> {
  return component.$store as Store<RootState>;
}
